import React from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import { Button, YesNoBtnRow } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import classes from './CreateScholasticCustomer.module.scss';
import { ScholasticProfileInputs } from '../../../../components/ScholasticProfileInputs/ScholasticProfileInputs';
import { ScholasticUserDataFormValue } from '../../../../interfaces/ScholasticUserProfileFormValue';
import { useAffiliateList } from './hooks/useAffiliateList';
import { scholasticCustomerService } from '../../../../services/scholasticCustomerService';

type CreateScholasticCustomerProps = {
  entityId: number;
  token: string;
  goToNextStep: () => void;
};

const CreateScholasticCustomer = observer(
  ({ entityId, token, goToNextStep }: CreateScholasticCustomerProps) => {
    const { affiliateList } = useAffiliateList(entityId);
    const formMethods = useForm<ScholasticUserDataFormValue>();

    const { handleSubmit, reset } = formMethods;

    const onSubmit = async ({ userData }: ScholasticUserDataFormValue) => {
      await scholasticCustomerService.selfCustomerSetup({ userData, entityId, token });

      goToNextStep();
    };

    const handleClearForm = () => {
      reset();
    };

    return (
      <>
        <div className={classes.title}>
          <h3>
            <span>Free Trial&nbsp;</span>
            Registration
          </h3>
          <p>Please enter your information below</p>
        </div>
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <ScholasticProfileInputs
              affiliateList={affiliateList}
              className={classes.inputsBlock}
            />
            <YesNoBtnRow yesText="Submit & Send">
              <Button variant="outlined" onClick={handleClearForm}>
                Clear Form
              </Button>
            </YesNoBtnRow>
          </form>
        </FormProvider>
      </>
    );
  },
);

export { CreateScholasticCustomer };
